export default "__VITE_ASSET__B9n8xW0x__"